import withAuthHeader from '../../utils/withAuthHeader';
import checkAuthorizationError from '../../utils/checkAuthorizationError';
import {
  mapFetchStoreHousResponse,
  mapFetchStoreExceptionResponse,
  mapOpenHoursToApiResponse,
  mapOpenHoursExceptionToApiResponse,
} from '../mappers/settings';

export const actionTypes = {
  SET_STORE_OPEN_HOURS: 'SET_STORE_OPEN_HOURS',
  SET_STORE_EXCEPTIONS_HOURS: 'SET_STORE_EXCEPTIONS_HOURS',
  SET_NEW_OPEN_HOURS: 'SET_NEW_OPEN_HOURS',
};

export const fetchStoreOpenHours =
  ({ storeId }) =>
  async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/dashboard/estabelecimentos/horariosfuncionamento`;
      const apiResponse = await api.get(url, {
        params: storeId ? { EstabelecimentoId: storeId } : {},
        ...withAuthHeader(),
      });

      const response = mapFetchStoreHousResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
      dispatch({
        type: actionTypes.SET_STORE_OPEN_HOURS,
        payload: response,
      });
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const fetchStoreExceptionsHours =
  ({ storeId }) =>
  async (dispatch, getState, api) => {
    let result = {};
    try {
      const url = `api/v1/dashboard/estabelecimentos/horariosexcecao`;
      const apiResponse = await api.get(url, {
        params: storeId ? { EstabelecimentoId: storeId } : {},
        ...withAuthHeader(),
      });

      const response = mapFetchStoreExceptionResponse(apiResponse.data);
      result = {
        success: true,
        data: response,
      };
      dispatch({
        type: actionTypes.SET_STORE_EXCEPTIONS_HOURS,
        payload: response,
      });
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const postStoreOpenHours =
  ({ data, storeId }) =>
  async (dispatch, getState, api) => {
    let result = {};
    try {
      const apiData = mapOpenHoursToApiResponse(data);
      const url = `api/v1/dashboard/estabelecimentos/horariosfuncionamento`;
      const apiResponse = await api.post(url, apiData, {
        params: storeId ? { EstabelecimentoId: storeId } : {},
        ...withAuthHeader(),
      });
      const response = apiResponse.data;

      result = {
        success: true,
        data: response,
      };

      dispatch({
        type: actionTypes.SET_NEW_OPEN_HOURS,
        payload: {
          success: true,
        },
      });
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };

export const postStoreException =
  ({ data, storeId }) =>
  async (dispatch, getState, api) => {
    let result = {};
    try {
      const apiData = mapOpenHoursExceptionToApiResponse(data);
      const url = `api/v1/dashboard/estabelecimentos/horariosexcecao`;
      const apiResponse = await api.post(url, apiData, {
        params: storeId ? { EstabelecimentoId: storeId } : {},
        ...withAuthHeader(),
      });
      const response = apiResponse.data;

      result = {
        success: true,
        data: response,
      };

      dispatch({
        type: actionTypes.SET_NEW_OPEN_HOURS,
        payload: {
          success: true,
        },
      });
    } catch (e) {
      checkAuthorizationError(e, dispatch);
      result = {
        error: e.message,
      };
    }
    return result;
  };
